(() => {
  if (window.FuntekRfqStats || window.Shopify?.designMode) return;
  const ENDPOINT = 'https://script.google.com/macros/s/AKfycbzQlaYLEQT1VeHAw7FDynkSIODRLsF3Kz2KvTtOIct7mi04Jl22j7C9X72Rz36-7S9A/exec';
  const KEY = 'rksJRuoBr3I1Hju9JZHrkvQjxRH92Tuql_n3lhVXRQo';
  const PREFIX = 'funtek_rfq_stats_';
  const DAY = 86400000;
  const memory = {};
  const get = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null') ?? memory[key]; } catch { return memory[key]; } };
  const put = (key, value) => { memory[key] = value; try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const id = () => crypto.randomUUID ? crypto.randomUUID() : 'rfq-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  const short = (value, limit = 160) => String(value || '').replace(/[\r\n\t]+/g, ' ').slice(0, limit);
  const params = new URLSearchParams(location.search);
  // Browser-level exclusion survives new tabs, restarts, and IP changes.
  let developer = false;
  try {
    if (params.get('funtek_rfq_dev') === '1') localStorage.setItem(PREFIX + 'developer', '1');
    if (params.get('funtek_rfq_dev') === '0') localStorage.removeItem(PREFIX + 'developer');
    developer = localStorage.getItem(PREFIX + 'developer') === '1';
  } catch { developer = params.get('funtek_rfq_dev') === '1'; }
  if (params.get('funtek_rfq_test') === '1') put(PREFIX + 'test', true);
  if (params.get('funtek_rfq_dev') === '0') put(PREFIX + 'test', false);
  if (developer) {
    const badge = document.createElement('div');
    badge.textContent = '内部访问 · 已排除统计';
    badge.id = 'funtek-rfq-internal-badge';
    badge.setAttribute('role', 'status');
    badge.style.cssText = 'position:fixed;bottom:32px;left:8px;z-index:2147483000;padding:5px 9px;border-radius:6px;background:#173c28;color:white;font:12px/1.5 system-ui;pointer-events:none';
    document.body.appendChild(badge);
  }
  let allowed = false;
  let visitor = '';
  let session = '';
  let queue = [];
  let busy = false;
  let retry = 0;
  let flushTimer;
  let impression = null;
  const test = () => developer || get(PREFIX + 'test') === true;
  const save = () => put(PREFIX + 'queue', queue.slice(-60));
  const schedule = (delay = 1500) => { clearTimeout(flushTimer); flushTimer = setTimeout(drain, delay); };
  const device = /Mobi|Android|iPhone/.test(navigator.userAgent) ? 'Mobile' : /iPad/.test(navigator.userAgent) ? 'Tablet' : 'Desktop';
  const channel = () => {
    const context = window.FuntekLeadContext?.snapshot?.();
    const touch = context?.session?.currentTouch;
    return short(touch ? [touch.source || 'direct', touch.medium || '(none)'].join(' / ') : params.get('utm_source') || (document.referrer ? new URL(document.referrer).hostname : 'direct'), 120);
  };
  const add = (type, extra = {}) => {
    if (!allowed) return;
    const event = {id:id(), type, visitorId:visitor, sessionId:session, at:Date.now(), page:location.origin + location.pathname,
      title:short(document.title), source:short(extra.source || '', 100), impressionId:impression?.id || '', submissionId:'',
      test:test() || developer, consent:true, device, channel:channel(), ...extra};
    if (queue.some(item => item.id === event.id)) return;
    queue.push(event);
    save();
    schedule();
  };
  function drain() {
    if (!allowed || busy) return;
    queue = queue.filter(event => Date.now() - event.at < DAY);
    save();
    if (!queue.length) return;
    const batch = queue.slice(0, 12);
    const body = JSON.stringify({key:KEY, kind:'rfq_stats', events:batch});
    if (body.length > 24000) return;
    busy = true;
    fetch(ENDPOINT, {method:'POST', mode:'no-cors', credentials:'omit', headers:{'Content-Type':'text/plain;charset=UTF-8'}, body, keepalive:true}).catch(() => {});
    setTimeout(() => {
      if (!allowed) { busy = false; return; }
      const callback = 'ftwa_rfq_' + Math.random().toString(36).slice(2);
      const script = document.createElement('script');
      let ended = false;
      const done = ok => {
        if (ended) return;
        ended = true;
        clearTimeout(timeout);
        delete window[callback];
        script.remove();
        busy = false;
        if (ok) {
          const sent = new Set(batch.map(event => event.id));
          queue = queue.filter(event => !sent.has(event.id));
          retry = 0;
          save();
          if (queue.length) schedule();
        } else if (++retry <= 3) schedule([8000,30000,120000][retry - 1]);
      };
      window[callback] = response => done(response?.ok && response.status === 'recorded');
      script.onerror = () => done(false);
      script.referrerPolicy = 'no-referrer';
      script.src = ENDPOINT + '?id=' + encodeURIComponent(batch[0].id) + '&key=' + encodeURIComponent(KEY) + '&callback=' + callback;
      const timeout = setTimeout(() => done(false), 10000);
      document.head.appendChild(script);
    }, 3500);
  }
  const confirm = () => {
    if (!allowed) return;
    const pending = get('funtek_rfq_confirmed_v1');
    if (!pending?.confirmedAt || Date.now() - pending.confirmedAt > DAY || !pending.id) return;
    add('inquiry_success', {id:'success-' + pending.id, submissionId:pending.id, source:pending.source || 'unknown',
      impressionId:pending.impressionId || '', page:pending.page, title:pending.title, at:pending.confirmedAt, test:pending.test === true || developer,
      visitorId:pending.visitorId || visitor, sessionId:pending.sessionId || session});
    try { sessionStorage.removeItem('funtek_rfq_confirmed_v1'); } catch {}
    delete memory.funtek_rfq_confirmed_v1;
  };
  const checkPrivacy = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') return;
    const previous = allowed;
    allowed = privacy.analyticsProcessingAllowed() === true;
    if (!allowed) {
      clearTimeout(flushTimer);
      queue = [];
      if (previous) {
        try { localStorage.removeItem(PREFIX + 'visitor'); } catch {}
        for (const key of [PREFIX+'queue', PREFIX+'session', PREFIX+'impression', 'funtek_rfq_submit_pending_v1', 'funtek_rfq_confirmed_v1']) {
          delete memory[key];
          try { sessionStorage.removeItem(key); } catch {}
        }
      }
      return;
    }
    if (previous) return;
    try {
      const stored = JSON.parse(localStorage.getItem(PREFIX + 'visitor') || 'null');
      visitor = stored?.id && stored.expires > Date.now() ? stored.id : id();
      localStorage.setItem(PREFIX + 'visitor', JSON.stringify({id:visitor,expires:Date.now()+90*DAY}));
    } catch { visitor = id(); }
    impression = get(PREFIX + 'impression');
    const old = get(PREFIX + 'session');
    session = old?.id && Date.now() - old.at < 1800000 ? old.id : id();
    put(PREFIX + 'session', {id:session,at:Date.now()});
    queue = (get(PREFIX + 'queue') || []).filter(event => Date.now()-event.at < DAY);
    const card = document.getElementById('funtek-quote-invite');
    if (card && !card.hidden) record({event:'quote_invite_view'});
    confirm();
    if (queue.length) schedule();
  };
  function record(detail) {
    if (!allowed) return;
    const types = {quote_invite_view:'invite_view',quote_invite_click:'invite_click',quote_invite_dismiss:'invite_dismiss',quote_drawer_open:'quote_open',rfq_auto_open:'rfq_auto_open'};
    const type = types[detail?.event];
    if (!type) return;
    if (type === 'invite_view') { impression = {id:id(),at:Date.now()}; put(PREFIX + 'impression',impression); }
    add(type, {source:detail.source || (type.startsWith('invite_') ? 'quote_invite_card' : detail.rfq_stage ? 'rfq_auto_stage_' + detail.rfq_stage : '')});
  }
  window.addEventListener('funtek:rfq-event', event => record(event.detail));
  window.addEventListener('funtek:inquiry-success', confirm);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!allowed) return;
    if (!form.matches('.frq-form')) {
      try { sessionStorage.removeItem('funtek_rfq_submit_pending_v1'); } catch {}
      delete memory.funtek_rfq_submit_pending_v1;
      return;
    }
    if (!form.checkValidity()) return;
    const submission = {id:id(),at:Date.now(),source:form.querySelector('[data-frq-open-source]')?.value || 'unknown',
      impressionId:impression?.id || '',visitorId:visitor,sessionId:session,page:location.origin+location.pathname,title:short(document.title),test:test()};
    put('funtek_rfq_submit_pending_v1', submission);
    for (const [name,value] of [['contact[Inquiry ID]',submission.id],['contact[Anonymous visitor ID]',visitor]]) {
      let input = form.querySelector('input[name="' + name + '"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
      input.value = value;
    }
  }, true);
  document.addEventListener('visitorConsentCollected', checkPrivacy);
  window.addEventListener('online', () => { retry = 0; schedule(); });
  window.addEventListener('pagehide', () => {
    if (!allowed || !queue.length || !navigator.sendBeacon) return;
    navigator.sendBeacon(ENDPOINT,new Blob([JSON.stringify({key:KEY,kind:'rfq_stats',events:queue.slice(0,12)})],{type:'text/plain;charset=UTF-8'}));
  });
  window.FuntekRfqStats = {version:'1.0.0',status:() => ({allowed,pending:queue.length,developer}),confirmSuccess:confirm};
  checkPrivacy();
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) checkPrivacy(); });
  setTimeout(checkPrivacy,2000);
})();
